import { Plan, SubscriptionPlanDTO, useTheme } from '@springbig/shared';
import { Box, VStack, HStack } from 'native-base';
import { Caption, H4 } from '~/shared/Typography';
import React from 'react';

type PlanBenefitsProps = {
    plan: Plan | SubscriptionPlanDTO;
    alignItems?: 'flex-start' | 'center' | 'flex-end';
};

const PlanBenefits = ({ plan, alignItems = 'flex-start' }: PlanBenefitsProps) => {

    const { primary, highlight_text } = useTheme();

    return (
        <Box flex={1} alignItems={alignItems}>
            <H4 text={'subscriptions.benefits'} />
            <VStack space={1} mx={alignItems === 'center' ? 'auto' : null}>
                { plan.human_readable_rewards.map((reward, index) => {

                    return (
                        <HStack key={index} space={2}>
                            <Box
                                borderRadius={'100%'}
                                w={2}
                                h={2}
                                backgroundColor={primary}
                                marginTop={1.5}
                                alignSelf={'flex-start'}
                            />
                            <Caption>
                                <Caption
                                    mr={2}
                                    style={{ textDecorationLine: plan.benefits[index]?.used ? 'line-through' : 'none' }}
                                >
                                    { reward }
                                </Caption>
                                { !!plan.benefits[index]?.used &&
                                    <Caption
                                        fontSize={10}
                                        color={highlight_text}
                                        style={{ textDecorationLine: 'none' }}
                                        text={'subscriptions.previously_used'}
                                    />
                                }
                            </Caption>
                        </HStack>
                    );
                })}
            </VStack>
        </Box>
    );
};

export default PlanBenefits;
